<mat-card class="searchBar">
      <dl-audit-trail-search></dl-audit-trail-search>
</mat-card> 
<div class="mat-elevation-z8 searchBar">
<table mat-table [dataSource]="dataSource" class="table" matSort (matSortChange)="announceSortChange($event)">

  <!-- Timestamp Column -->
  <ng-container matColumnDef="timestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by timestamp" style="color:#333333; font-size:14px;padding:0 10px 0 35px" class="truncate-text"> Timestamp </th>
    <td mat-cell *matCellDef="let element" class="truncate-text" [title]="appUtils.formatDateWithTime(element.timestamp)"> 
      <span class="wrap">
        {{appUtils.formatDateWithTimeUptoSec(element.timestamp)}} 
      </span>
    </td>
  </ng-container>

  <!-- User Column -->
  <ng-container matColumnDef="modifiedBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by modifiedBy" style="color:#333333; font-size:14px;padding:0 10px" class="truncate-text"> User </th>
    <td mat-cell *matCellDef="let element" class="truncate-text" [title]="element.modifiedBy"> 
      <span class="wrap">
        {{element.modifiedBy}}
      </span> 
    </td>
  </ng-container>

  <!-- Role Column -->
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by role" style="color:#333333; font-size:14px;padding:0 10px" class="truncate-text"> Role </th>
    <td mat-cell *matCellDef="let element" class="truncate-text" [title]="element.role"> 
      <span class="wrap">
        {{element.role}}
      </span> 
    </td>
  </ng-container>

  <!-- Property Name Column -->
  <ng-container matColumnDef="propertyName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by propertyName" style="color:#333333; font-size:14px;padding:0 10px" class="truncate-text"> Property Name </th>
    <td mat-cell *matCellDef="let element" class="truncate-text" [title]="element.propertyName"> 
      <span class="wrap">
        {{element.propertyName}} 
      </span>
    </td>
  </ng-container>

  <!-- Old Value Column -->
  <ng-container matColumnDef="oldValue">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by oldValue" style="color:#333333; font-size:14px;padding:0 10px" class="truncate-text"> Previous Value </th>
    <td mat-cell *matCellDef="let element" class="truncate-text">
       <div *ngIf="isString(element.oldValue)" class="truncate-text" [title]="element.oldValue">
        <span class="wrap">
          {{element.oldValue}}
        </span>
      </div> 
      <mat-chip *ngIf="!isString(element.oldValue)" [title]="toJSON(element.oldValue)" class="list-source-chip truncate-text" style="width:42px" oneChip oneChipAppearance="outline"> 
         Object
      </mat-chip>
      </td>
  </ng-container>

   <!-- New Value Column -->
   <ng-container matColumnDef="newValue">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by newValue" style="color:#333333; font-size:14px;padding:0 10px" class="truncate-text"> New Value </th> 
    <td mat-cell *matCellDef="let element" class="truncate-text"> 
      <div *ngIf="isString(element.newValue)" class="truncate-text" [title]="element.newValue">
        <span class="wrap">
          {{element.newValue}}
        </span>
      </div> 
      <mat-chip *ngIf="!isString(element.newValue)" [title]="toJSON(element.newValue)" class="list-source-chip truncate-text" style="width:42px;" oneChip oneChipAppearance="outline"> 
        Object
      </mat-chip>
    </td>
  </ng-container> 
  
  <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div style="display:flex;" class="searchBar">
  <mat-paginator style="margin:auto; padding:auto;" [pageSizeOptions]="[10]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
  <div>
    <button one-secondary-button mat-stroked-button style="margin:10px 25px 10px 0" [mat-dialog-close]="true" (click)="closeClicked()"> Close</button>
  </div>
</div>
</div>

 
